// inputs in units of feet, feet, and acres respectivly
export function slopeCalc(contourLength, contourInterval, drainageArea) {
  const acersToFeet = 435.6;
  const slope = (contourLength * contourInterval) / drainageArea / acersToFeet;
  // round to nearest 100th
  return Math.round(slope * 100) / 100;
}
